import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const TicketsWrapper = styled.div(() =>
  mq({
    borderTop: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    marginTop: defaultTheme.spacing.m,
  }),
);

export const DetailWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
  }),
);

export const Detail = styled.div((props: { disabled: boolean }) =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '130px',
    opacity: props.disabled ? defaultTheme.button.opacity.disabled : 1,
    fontSize: defaultTheme.font.size.m,
    padding: `${defaultTheme.spacing.s} 0`,
    wordBreak: 'break-all',
    '& > span': {
      fontWeight: 'bold',
    },
    '& > p': {
      fontSize: defaultTheme.font.size.s,
    },
  }),
);

export const Refund = styled.div(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.s,
  }),
);

export const Odds = styled.div(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.s,
    margin: '2px 0',
  }),
);

export const OddsWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    marginTop: defaultTheme.spacing.l,
    borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
  }),
);

export const OddsDetail = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: defaultTheme.font.size.m,
    marginBottom: defaultTheme.spacing.l,
    p: {
      fontSize: defaultTheme.font.size.xs,
      lineHeight: defaultTheme.font.height.base,
      color: defaultTheme.color.grayScale.dark,
    },
    span: {
      display: 'inline-block',
      textAlign: 'right',
    },
  }),
);
